import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'error-page',
    templateUrl: './error-page.html',
    styleUrls: ['./error-page.css', './error-page.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class ErrorPageComponent {
    goBack() {
        window.history.back();
    };
}



// WEBPACK FOOTER //
// ./web/static/components/error-page/error-page.ts